import React, { useEffect } from "react";
import { Modal, Button, Form, Input, Typography } from "antd";

interface ExerciseModalProps {
  open: boolean;
  mode: "create" | "edit";
  onClose: () => void;
  onSave: (values: { name: string }) => void;
  initialValues?: { name: string };
}

export default function ExerciseModal({
  open,
  mode,
  onClose,
  onSave,
  initialValues,
}: ExerciseModalProps): React.ReactElement {
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      if (mode === "edit" && initialValues) {
        form.setFieldsValue(initialValues);
      } else {
        form.resetFields();
      }
    }
  }, [open, mode, initialValues, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      onSave(values);
      form.resetFields();
    } catch (error) {
      console.error("Validation failed:", error);
    }
  };

  const handleClose = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title={mode === "edit" ? "Edit Avoda" : "Add Avoda"}
      open={open}
      onCancel={handleClose}
      width={400}
      footer={null}
      destroyOnHidden
    >
      <div style={{ margin: "24px 0" }}>
        <Typography.Text>
          {mode === "edit"
            ? "Changing the avoda name will update it across all Vaads and for all users where this avoda is currently used."
            : "You can add a new avoda for your students here"}
        </Typography.Text>
      </div>

      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          label={
            <span>
              {" "}
              {mode === "edit" ? "Edit avoda name" : "Enter avoda name"}
            </span>
          }
          name="name"
          rules={[
            { required: true, message: "Please enter avoda name" },
            { min: 2, message: "Name must be at least 2 characters" },
            { max: 100, message: "Name must be less than 100 characters" },
          ]}
        >
          <Input placeholder="Type avoda name" />
        </Form.Item>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 12,
            marginTop: 24,
          }}
        >
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="primary" onClick={() => form.submit()}>
            Save
          </Button>
        </div>
      </Form>
    </Modal>
  );
}
